// INITIALIZATION
document.addEventListener('DOMContentLoaded', checkScrollPosition);

// ACTIONS
jQuery("#auditions-btn").on('click', function () {
	jQuery.redirect("/productions/upcoming-auditions/", { show: jQuery(this).attr('data-show') });
});

window.addEventListener('scroll', optimizedScrollHandler, { passive: true });